import { updateObject } from '../../shared/utility';
import {
   COLLECTOR_TRANSACTION_START,
   COLLECTOR_TRANSACTION_SUCCESS,
   COLLECTOR_TRANSACTION_FAIL,
   COLLECTOR_HISTORY_START,
   COLLECTOR_HISTORY_SUCCESS,
   COLLECTOR_HISTORY_FAIL
} from '../actions/actionTypes';


const initialState = {
    message:null,
    error:null,
    loading: false,
    history:null,
}

const collectorTransactionStart=(state,action)=>{
    return updateObject(state,{message:null,error:null,loading:true});
}

const collectorTransactionSuccess=(state,action)=>{
    return updateObject(state,{message:'Collector Transaction Success',error:null,loading:false});
}

const collectorTransactionFail=(state,action)=>{
    return updateObject(state,{message:null,error:action.payload,loading:false});
}

const collectorHistoryStart=(state,action)=>{
    return updateObject(state,{message:null,error:null,loading:true});
}

const collectorHistorySuccess=(state,action)=>{
    return updateObject(state,{message:'get collector history success',history:action.payload,error:null,loading:false});
}

const collectorHistoryFail=(state,action)=>{
    return updateObject(state,{message:null,error:action.payload,loading:false});
}

const collectorReducer=(state=initialState,action)=>{
    switch(action.type){
        case COLLECTOR_TRANSACTION_START:
            return collectorTransactionStart(state,action);
        case COLLECTOR_TRANSACTION_SUCCESS:
            return collectorTransactionSuccess(state,action);
        case COLLECTOR_TRANSACTION_FAIL:
            return collectorTransactionFail(state,action);
        case COLLECTOR_HISTORY_START:
            return collectorHistoryStart(state,action);
        case COLLECTOR_HISTORY_SUCCESS:
            return collectorHistorySuccess(state,action);
        case COLLECTOR_HISTORY_FAIL:
            return collectorHistoryFail(state,action);
        default:
            return state;
    }
}

export default collectorReducer;